import { createAction } from '@reduxjs/toolkit';

export const workflowsPageEntered = createAction('CLIENT_WORKFLOWS_PAGE_ENTERED');
export const workflowsPageLoaded = createAction('CLIENT_WORKFLOWS_PAGE_LOADED');

export const workflowsLoading = createAction('WORKFLOWS_LOADING');
export const workflowsLoadingSuccess = createAction('WORKFLOWS_LOADING_SUCCESS');
export const workflowsLoadingFail = createAction('WORKFLOWS_LOADING_FAIL');
